import React from 'react';
import '../css/winners.css';
import '../App.css';
import {
  AcceptanceSpeech,
  PredictionQuote,
  ScoreLine,
  YearContainer,
} from '../components/winners';

export const Winners = () => (
  <>
    <YearContainer year={'2024'}>
      <p>Winners for 2024 TBC</p>
    </YearContainer>
    <YearContainer year={'2023'}>
      <ScoreLine position="1" winner="GREG">
        <PredictionQuote>
          A large sea animal like a whale or dolphin is washed on to the
          Brighton and hove beach and the locals come together to save it
        </PredictionQuote>
        Incredible! Within only 3 days of the prediction, on 3rd January{' '}
        <a href="https://www.bbc.co.uk/news/uk-england-sussex-64150010">
          this happened only slightly along the coast at Hastings
        </a>
        . This guess was the clear winner, as it was selected by 5 of the 7
        judges. Cracking guess! Greg wins 3 books, selected by last year's 3
        winners:
        <br />
        <a href="https://www.amazon.co.uk/Hundred-Year-Old-Man-Climbed-Window-Disappeared/dp/0349141800">
          The Hundred-Year-Old Man Who Climbed Out of the Window and
          Disappeared, by Jonas Jonasson
        </a>
        , chosen by last year's 1st place Paul D
        <br />
        <a href="https://www.amazon.co.uk/Our-Final-Invention-Artificial-Intelligence/dp/0312622376">
          Our Final Invention: Artificial Intelligence and the End of the Human
          Era, by James Barrat
        </a>
        , chosen by last year's 2nd place Dan C
        <br />
        <a href="https://www.amazon.co.uk/Watchmen-Alan-Moore/dp/1852860243">
          Watchmen, by Alan Moore
        </a>
        , chosen by last year's 3rd place Alan
        <AcceptanceSpeech>
          Just want to thank everyone who believed in me, the people of Hastings
          for dragging that poor dolphin ashore but most of all Jon “Mullington”
          Mulhern for inviting me to play his game
        </AcceptanceSpeech>
      </ScoreLine>
      <ScoreLine position="2" winner="BRENDAN">
        <PredictionQuote>
          A new dance craze emerges on Tick Tock called “The King Charles”
          following a little jig he does at the coronation
        </PredictionQuote>
        <PredictionQuote>
          The BBC pulls the plug on “The One Show”. Because it's shit.
        </PredictionQuote>
        Although the game is about best single prediction, Brendan received 3
        judges' votes each for two of his predictions, so he nets second place
        with two great guesses. King Charles' dance might not have been at the
        coronation,{' '}
        <a href="https://www.cosmopolitan.com/uk/reports/a45202102/king-charles-dancing-instagram/">
          but did get at least 2.2m views.
        </a>{' '}
        As for the One Show, a great prediction that it would be brought this
        year down by the weight of its mediocrity.
      </ScoreLine>
      <ScoreLine position="3" winner="REMI">
        <PredictionQuote>
          Steve’s imaginary gf “dies” when he realises he’ll have to introduce
          her to us
        </PredictionQuote>
        Our mutual friend Steve failed to introduce us to his girlfriend, then
        mysteriously fled the country to go and live in Berlin. The judges
        seemed to enjoy this. Well done Remi. It's also worth reading his{' '}
        <a href="https://predictions.jonmulhern.co.uk/query/authors=REMI&year=2023">
          other guesses
        </a>{' '}
        as it was all round a great set.
        <AcceptanceSpeech>
          Yes!!! Winner. I have no memory of what I predicted
        </AcceptanceSpeech>
      </ScoreLine>
      <ScoreLine position="MOST CREATIVE PREDICTIONS" winner="SAM H">
        Sam H put in both the effort, and the word count, when it came to his
        unhinged predictions. It feels like reading the predictions of a mad
        scientist.{' '}
        <a href="https://predictions.jonmulhern.co.uk/query/year=2023&authors=SAM+H">
          Read them here.
        </a>
        <AcceptanceSpeech>
          Thanks to everyone who voted for me. Trump for Prez
        </AcceptanceSpeech>
      </ScoreLine>
      <ScoreLine position="WILDEST OVERALL PREDICTION SET" winner="DAVE B">
        Dave's set of predictions made no cautious efforts to remain correct.{' '}
        <a href="https://predictions.jonmulhern.co.uk/query/year=2023&authors=DAVE+B">
          All guesses were all over the place
        </a>
        , well done Dave for embracing the true spirit of the game. You win a
        well earned pint.
        <AcceptanceSpeech>
          Some would call me a hero for these predictions. Not the hero we need
          certainly, but possibly the hero we deserve.
        </AcceptanceSpeech>
      </ScoreLine>
    </YearContainer>
    <YearContainer year={'2022'}>
      <ScoreLine position="1" winner="PAUL D">
        <PredictionQuote>
          There will be 3 prime ministers inc Boris Johnson.
        </PredictionQuote>
        There was no doubt from the judges, Paul D was the clear winner with
        this excellent guess. I think we'd all suspected 2022 might see a new
        PM, but to go further and say there would be three is a great shout.
        Paul wins three books selected by last year's three winners:
        <br />
        <a href="https://www.amazon.co.uk/Long-Way-Down-Nick-Hornby/dp/1594481938">
          A Long Way Down, by Nick Hornby
        </a>
        , chosen by last year's 1st place Cheryll
        <br />
        <a href="https://www.amazon.co.uk/Flavour-Thesaurus-Niki-Segnit/dp/0747599777">
          The Flavour Thesaurus, by Niki Segnit
        </a>
        , chosen by last year's 2nd place Thom
        <br />
        <a href="https://www.amazon.co.uk/Etymologicon-Circular-through-Connections-Language/dp/1848313071">
          The Etymologicon: A Circular Stroll through the Hidden Connections of
          the English Language, by Mark Forsyth
        </a>
        , chosen by last year's 3rd place Dan S
        <AcceptanceSpeech>
          I'd like to thank the Tory party for an entertaining year
        </AcceptanceSpeech>
      </ScoreLine>
      <ScoreLine position="2" winner="CURTIS">
        <PredictionQuote>
          The average household annual energy bill tops 2k
        </PredictionQuote>
        Curtis' whole set did well, with 4 correct. But this was the standout
        prediction. Even before the Ukraine conflict had started, he had
        carefully thought forward to knock on effects for when it would begin. A
        logical and smart move.
        <AcceptanceSpeech>How exciting</AcceptanceSpeech>
      </ScoreLine>
      <ScoreLine position="3" winner="ALAN">
        <PredictionQuote>
          The Tory leadership race hots up with Priti, Rishi and Liz in
          contention, in the end Liz Truss wins the competition and takes home a
          speedboat.
        </PredictionQuote>
        Another UK political guess makes the top 3 - Alan's very nice guess that
        there would be a leadership race with Liz Truss ultimately beating
        Rishi. Taking home a proverbial speedboat in the form of the nuclear
        launch code briefcase.
        <AcceptanceSpeech>
          I would like to thank my agent, my teachers at school (especially my
          swimming coach) and most of all my wife who suggested Liz. I wish that
          rather than the speedboat I had mentioned the £115k a year pension- a
          fine reward for tanking the economy in 49 days.
        </AcceptanceSpeech>
      </ScoreLine>
      <ScoreLine position="MOST CREATIVE PREDICTION" winner="ADAM N">
        Adam N came up with some absolutely batshit guesses, which{' '}
        <a href="https://predictions.jonmulhern.co.uk/query/year=2022authors=ADAM+N">
          can be read here.
        </a>{' '}
        Amongst them all, one came through which was genuinely impressive,
        regarding a high profile football pundit being sacked.
        <AcceptanceSpeech>
          Thank you everyone. I'd like to thank the venn diagram formed between
          my parents and the movies for covering most of morality. Also
          evolution for keeping my balls safe and warm. Also chillis. And Jon.
          Good night.
        </AcceptanceSpeech>
      </ScoreLine>
      <ScoreLine position="WILDEST OVERALL PREDICTION SET" winner="STAS">
        Stas spread his bets across many areas, and with only wild outcomes,
        which is very much in the spirit of the game. Eight guesses, all in
        different categories, all creative. A great set that's undeniably wild.{' '}
        <a href="https://predictions.jonmulhern.co.uk/query/year=2022authors=STAS">
          They can be read here.
        </a>
      </ScoreLine>
    </YearContainer>
    <YearContainer year={'2021'}>
      <ScoreLine position="1" winner="CHERYLL">
        <PredictionQuote>a cure for alzheimers</PredictionQuote>
        Cheryll's excellent set took first place mainly from a partly correct
        prediction. A breakthrough in Alzheimer's treatment has brought us
        closer than ever to a cure.
        <PredictionQuote>Kamala Harris first woman president</PredictionQuote>
        <PredictionQuote>
          A major volcano eruption affecting the climate
        </PredictionQuote>
        Kamala Harris' very brief presidency, and a volcano eruption, really
        secured the win. On 19th Nov, Kamala Harris becomes president for 85
        minutes while Biden is placed under anaesthesia and temporarily steps
        down as president. La Palma saw a major volcanic eruption, though it's
        hard to assess its climate impact.
      </ScoreLine>
      <ScoreLine position="2" winner="THOM">
        <PredictionQuote>There's a ham shortage</PredictionQuote>
        Thom made a prediction that{' '}
        <a href="https://www.mashed.com/709285/what-you-need-to-know-about-the-christmas-2021-ham-shortage/">
          came true
        </a>
        , despite having been (at least partly) as a joke. I love it and
        humorous predictions that sometimes become real are the most fun part of
        having this competition.
        <PredictionQuote>Lad baby is Christmas number one</PredictionQuote>
        <PredictionQuote>
          Boris Johnson gets ousted like the sick muthafucka he is
        </PredictionQuote>
        Sure enough Lad Baby were no.1 again, and Boris Johnson may have stayed
        but he certainly came damn close to getting ousted.
      </ScoreLine>
      <ScoreLine position="3" winner="DAN S">
        <PredictionQuote>Trump starts his own TV network</PredictionQuote>
        Dan secured third place mainly because of his prediction about Trump
        starting a TV network. While it may not have been a TV network, he did
        announce and later launch a Twitter-like social network, Truth Social.
        <PredictionQuote>Prince Philip</PredictionQuote>
        Dan also predicted the death of Prince Philip, however given his age
        there was nothing impressive about it as a prediction and it was not a
        factor in his win.
      </ScoreLine>
    </YearContainer>
  </>
);
